import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.DepositoBancoDTO;
import { columnas } from "./columns";
import { DepositoBancoFiltro } from "app/models/requireme";
const resource = resources.DepositoBanco;
export class DepositoBancoList extends React.PureComponent {


    onContabilizar = (x: Entity) => history.go(`./${x.IdRegistro}`);
    onConsultar = (x: Entity) => history.go(`./${x.IdRegistro}`);

    onRegresar = () => history.go('../');

    items = observeResource(resource.Query, {Fecha: null} as DepositoBancoFiltro);
    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Depositos bancos" onRegresar={this.onRegresar}>
                </kea.Title>

                <kea.Grid2 columnas={cols} cookieKey={"DepositoBancoListCookieKey"} items={this.items} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/depositobanco/list/list.tsx